// 邮箱验证
export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

// 密码强度验证
export const validatePassword = (password) => {
  const errors = [];
  
  if (password.length < 8) {
    errors.push('密码至少需要8个字符');
  }
  
  if (!/[a-z]/.test(password)) {
    errors.push('密码需要包含小写字母');
  }
  
  if (!/[A-Z]/.test(password)) {
    errors.push('密码需要包含大写字母');
  }
  
  if (!/[0-9]/.test(password)) {
    errors.push('密码需要包含数字');
  }
  
  return {
    isValid: errors.length === 0,
    errors,
    strength: getPasswordStrength(password)
  };
};

// 密码强度评分
const getPasswordStrength = (password) => {
  let strength = 0;
  
  if (password.length >= 8) strength++;
  if (password.length >= 12) strength++;
  if (/[a-z]/.test(password)) strength++;
  if (/[A-Z]/.test(password)) strength++;
  if (/[0-9]/.test(password)) strength++;
  if (/[^a-zA-Z0-9]/.test(password)) strength++;
  
  if (strength <= 2) return 'weak';
  if (strength <= 4) return 'medium';
  return 'strong';
};

// 用户名验证
export const validateUsername = (username) => {
  const errors = [];
  
  if (username.length < 3) {
    errors.push('用户名至少需要3个字符');
  }
  
  if (username.length > 20) {
    errors.push('用户名最多20个字符');
  }
  
  if (!/^[a-zA-Z0-9_]+$/.test(username)) {
    errors.push('用户名只能包含字母、数字和下划线');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// 配置名称验证
export const validateConfigName = (name) => {
  const errors = [];
  
  if (!name || name.trim() === '') {
    errors.push('配置名称不能为空');
  }
  
  if (name.length > 100) {
    errors.push('配置名称最多100个字符');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// 价格验证
export const validatePrice = (price) => {
  const errors = [];
  const numPrice = parseFloat(price);
  
  if (isNaN(numPrice)) {
    errors.push('价格必须是数字');
  } else if (numPrice < 0) {
    errors.push('价格不能为负数');
  } else if (numPrice > 1000000) {
    errors.push('价格不能超过100万');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// 重量验证
export const validateWeight = (weight) => {
  const errors = [];
  const numWeight = parseFloat(weight);
  
  if (isNaN(numWeight)) {
    errors.push('重量必须是数字');
  } else if (numWeight < 0) {
    errors.push('重量不能为负数');
  } else if (numWeight > 50000) {
    errors.push('重量不能超过50kg');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// 文件大小验证
export const validateFileSize = (file, maxSizeMB) => {
  const maxSize = maxSizeMB * 1024 * 1024;
  return {
    isValid: file.size <= maxSize,
    error: file.size > maxSize ? `文件大小不能超过${maxSizeMB}MB` : null
  };
};

// 文件类型验证
export const validateFileType = (file, allowedTypes) => {
  const ext = '.' + file.name.split('.').pop().toLowerCase();
  return {
    isValid: allowedTypes.includes(ext),
    error: !allowedTypes.includes(ext) ? `不支持的文件类型，仅支持: ${allowedTypes.join(', ')}` : null
  };
};
